import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Separator } from './ui/separator';

export const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <footer className="bg-[#2C2C2C] text-white">
      {/* Newsletter Section */}
      <div className="bg-[#6B4E37] py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl font-seasons font-light mb-3 text-white">
              Join Our Community
            </h3>
            <p className="text-white/80 font-montserrat mb-6">
              Subscribe to receive exclusive offers, styling tips, and updates on new arrivals
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <Input
                type="email"
                placeholder="Enter your email"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/60 focus:border-white" />

              <Button className="bg-white text-[#6B4E37] hover:bg-[#FAF9F7] font-montserrat tracking-wider uppercase px-8">
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <h3 className="text-2xl font-seasons font-light mb-4 text-[#C4B5A0]">
              Sachdeva Sons
            </h3>
            <p className="text-white/70 font-montserrat text-sm leading-relaxed mb-6">
              Crafting timeless elegance in ethnic wear since 1985. Your destination for authentic Indian fashion.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="bg-white/10 hover:bg-[#C4B5A0] p-2 rounded-full transition-colors duration-300">

                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 hover:bg-[#C4B5A0] p-2 rounded-full transition-colors duration-300">

                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 hover:bg-[#C4B5A0] p-2 rounded-full transition-colors duration-300">

                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div>
            <h4 className="font-montserrat text-sm tracking-wider uppercase mb-6 text-[#C4B5A0]">
              Shop
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
                  New Arrivals
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
                  Chanderi Collection
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
                  Silk Collection
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
                  Party Wear
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
                  Pakistani Suits
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Care Column */}
          <div>
            <h4 className="font-montserrat text-sm tracking-wider uppercase mb-6 text-[#C4B5A0]">
              Customer Care
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => handleNavigate('/contact')}
                  className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate('/shipping-delivery')}
                  className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  Shipping & Delivery
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate('/returns-exchange')}
                  className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  Returns & Exchange
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate('/size-guide')}
                  className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  Size Guide
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate('/faqs')}
                  className="text-white/70 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  FAQs
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-montserrat text-sm tracking-wider uppercase mb-6 text-[#C4B5A0]">
              Get in Touch
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <span className="font-montserrat !text-sm text-white/70">
                  52, Krishna Cloth Market, Chandni Chowk, Delhi - 110006
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#C4B5A0] flex-shrink-0" />
                <span className="font-montserrat !text-sm text-white/70">+91 9811193388</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#C4B5A0] flex-shrink-0" />
                <span className="text-white/70 font-montserrat text-sm">hello@sachdevasons.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Separator className="bg-white/10" />

      {/* Bottom Bar */}
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 font-montserrat text-sm text-center md:text-left">
            © 2025 Sachdeva Sons. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/60 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/60 hover:text-[#C4B5A0] font-montserrat text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>);
};